(() => {
  if (window.SSStickyProductBarReady) return;
  window.SSStickyProductBarReady = true;

  const section = document.querySelector('[id^="SSProduct-"]');
  const form = section?.querySelector('.ss-product-form');
  const mainAdd = form?.querySelector('.ss-button--cart');

  if (!section || !form || !mainAdd) return;

  const image =
    section.querySelector('.ss-gallery__media.is-active img') ||
    section.querySelector('.ss-gallery__main img') ||
    section.querySelector('.ss-gallery img') ||
    section.querySelector('img');

  const title =
    section.querySelector('.ss-product__title, h1')?.textContent?.trim() ||
    document.title.split('–')[0].trim();

  const price =
    section.querySelector(
      '.ss-product__price, .ss-price, [class*="price"]'
    )?.textContent?.replace(/\s+/g, ' ')?.trim() || '';

  const bar = document.createElement('aside');
  bar.className = 'ss-sticky-product-bar';
  bar.setAttribute('aria-label', 'Quick product purchase');
  bar.innerHTML = `
    <div class="ss-sticky-product-bar__inner">
      <div class="ss-sticky-product-bar__product">
        <div class="ss-sticky-product-bar__image">
          ${image ? `<img src="${image.currentSrc || image.src}" alt="">` : ''}
        </div>

        <div class="ss-sticky-product-bar__copy">
          <strong>${title}</strong>
          ${price ? `<span>${price}</span>` : ''}
        </div>
      </div>

      <div class="ss-sticky-product-bar__actions">
        <button type="button" class="ss-sticky-product-bar__add">
          Add to Cart
        </button>

        <div class="ss-sticky-product-bar__quantity" hidden>
          <button type="button" data-mini-action="minus" aria-label="Decrease quantity">−</button>
          <span aria-live="polite">1</span>
          <button type="button" data-mini-action="plus" aria-label="Increase quantity">+</button>
        </div>
      </div>
    </div>
  `;

  document.body.appendChild(bar);

  const miniAdd = bar.querySelector('.ss-sticky-product-bar__add');
  const miniQuantity = bar.querySelector(
    '.ss-sticky-product-bar__quantity'
  );
  const miniValue = miniQuantity.querySelector('span');

  function mainControl() {
    return form.querySelector('.ss-ajax-quantity');
  }

  function sync() {
    const control = mainControl();
    const mainValue = control?.querySelector('span');
    const quantity = Number.parseInt(
      mainValue?.dataset.quantity || mainValue?.textContent,
      10
    );

    const productInCart =
      control &&
      !control.hidden &&
      control.classList.contains('is-visible') &&
      quantity > 0;

    miniAdd.hidden = productInCart;
    miniQuantity.hidden = !productInCart;

    if (productInCart) {
      miniValue.textContent = String(quantity);
      miniValue.dataset.quantity = String(quantity);
    }

    const variant = form.querySelector('[name="id"]');
    miniAdd.disabled = Boolean(mainAdd.disabled || variant?.disabled);
  }

  miniAdd.addEventListener('click', () => {
    if (mainAdd.disabled) return;

    miniAdd.classList.add('is-loading');
    miniAdd.textContent = 'Adding…';
    mainAdd.click();

    window.setTimeout(() => {
      sync();
      miniAdd.classList.remove('is-loading');
      miniAdd.textContent = 'Add to Cart';
    }, 950);
  });

  miniQuantity.addEventListener('click', (event) => {
    const action = event.target.closest('[data-mini-action]')?.dataset
      .miniAction;

    if (!action) return;

    const control = mainControl();
    const mainButton = control?.querySelector(
      action === 'plus'
        ? 'button[data-action="plus"]'
        : 'button[data-action="minus"]'
    );

    if (!mainButton || mainButton.disabled) return;

    miniQuantity.classList.add('is-loading');
    mainButton.click();

    window.setTimeout(() => {
      sync();
      miniQuantity.classList.remove('is-loading');
      miniValue.classList.remove('is-changing');
      requestAnimationFrame(() =>
        miniValue.classList.add('is-changing')
      );
    }, 700);
  });

  form.addEventListener('change', () => {
    window.setTimeout(sync, 100);
  });

  const stateObserver = new MutationObserver(sync);
  stateObserver.observe(form, {
    subtree: true,
    childList: true,
    attributes: true,
    characterData: true,
    attributeFilter: ['hidden', 'class', 'disabled', 'data-quantity']
  });

  const visibilityTarget =
    form.querySelector('.ss-product__buttons') || mainAdd;

  const visibilityObserver = new IntersectionObserver(
    ([entry]) => {
      const shouldShow =
        !entry.isIntersecting &&
        entry.boundingClientRect.bottom < 0 &&
        window.scrollY > 300;

      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    },
    {
      threshold: 0.08
    }
  );

  visibilityObserver.observe(visibilityTarget);
  sync();

  const style = document.createElement('style');
  style.textContent = `
    .ss-sticky-product-bar {
      position: fixed;
      z-index: 99990;
      right: 0;
      bottom: 0;
      left: 0;
      padding: 10px 18px max(10px, env(safe-area-inset-bottom));
      pointer-events: none;
      opacity: 0;
      transform: translateY(calc(100% + 20px));
      transition:
        opacity 260ms ease,
        transform 460ms cubic-bezier(0.22, 1, 0.36, 1);
    }

    .ss-sticky-product-bar.is-visible {
      pointer-events: auto;
      opacity: 1;
      transform: translateY(0);
    }

    .ss-sticky-product-bar__inner {
      width: min(1180px, 100%);
      min-height: 74px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      margin: auto;
      padding: 9px 12px 9px 10px;
      border: 1px solid rgba(255, 255, 255, 0.58);
      border-radius: 18px;
      background: rgba(255, 255, 255, 0.88);
      box-shadow: 0 18px 55px rgba(20, 15, 12, 0.2);
      backdrop-filter: blur(18px) saturate(145%);
    }

    .ss-sticky-product-bar__product {
      min-width: 0;
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .ss-sticky-product-bar__image {
      width: 56px;
      height: 56px;
      flex: 0 0 56px;
      overflow: hidden;
      border-radius: 12px;
      background: #f4efeb;
    }

    .ss-sticky-product-bar__image img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: contain;
    }

    .ss-sticky-product-bar__copy {
      min-width: 0;
      display: grid;
      gap: 3px;
      color: #171717;
    }

    .ss-sticky-product-bar__copy strong {
      max-width: 520px;
      overflow: hidden;
      font-size: 15px;
      line-height: 1.25;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ss-sticky-product-bar__copy span {
      font-size: 14px;
      font-weight: 700;
    }

    .ss-sticky-product-bar__actions {
      width: min(330px, 42vw);
      flex: 0 0 auto;
    }

    .ss-sticky-product-bar__add,
    .ss-sticky-product-bar__quantity {
      width: 100%;
      min-height: 52px;
      border: 1px solid #171717;
      border-radius: 12px;
      color: #fff;
      background: #171717;
    }

    .ss-sticky-product-bar__add {
      padding: 0 22px;
      font: inherit;
      font-weight: 700;
      cursor: pointer;
      transition: transform 130ms ease, opacity 180ms ease;
    }

    .ss-sticky-product-bar__add:hover {
      transform: translateY(-2px);
    }

    .ss-sticky-product-bar__add:active {
      transform: scale(0.97);
    }

    .ss-sticky-product-bar__add.is-loading,
    .ss-sticky-product-bar__quantity.is-loading {
      opacity: 0.6;
      pointer-events: none;
    }

    .ss-sticky-product-bar__quantity {
      display: grid;
      grid-template-columns: 1fr 70px 1fr;
      align-items: center;
      overflow: hidden;
    }

    .ss-sticky-product-bar__quantity[hidden],
    .ss-sticky-product-bar__add[hidden] {
      display: none !important;
    }

    .ss-sticky-product-bar__quantity button {
      height: 100%;
      border: 0;
      color: inherit;
      background: transparent;
      font: inherit;
      font-size: 22px;
      cursor: pointer;
    }

    .ss-sticky-product-bar__quantity button:hover {
      background: rgba(255, 255, 255, 0.12);
    }

    .ss-sticky-product-bar__quantity span {
      text-align: center;
      font-size: 16px;
      font-weight: 700;
    }

    .ss-sticky-product-bar__quantity span.is-changing {
      animation: ssMiniQuantityPop 220ms ease;
    }

    @keyframes ssMiniQuantityPop {
      50% { transform: scale(1.2); }
    }

    @media (max-width: 749px) {
      .ss-sticky-product-bar {
        padding: 7px 8px max(7px, env(safe-area-inset-bottom));
      }

      .ss-sticky-product-bar__inner {
        min-height: 66px;
        gap: 9px;
        padding: 7px;
        border-radius: 15px;
      }

      .ss-sticky-product-bar__image {
        width: 50px;
        height: 50px;
        flex-basis: 50px;
      }

      .ss-sticky-product-bar__copy strong {
        max-width: 34vw;
        font-size: 12px;
      }

      .ss-sticky-product-bar__copy span {
        font-size: 12px;
      }

      .ss-sticky-product-bar__actions {
        width: 43vw;
      }

      .ss-sticky-product-bar__add,
      .ss-sticky-product-bar__quantity {
        min-height: 48px;
        border-radius: 10px;
      }

      .ss-sticky-product-bar__add {
        padding: 0 10px;
        font-size: 12px;
      }

      .ss-sticky-product-bar__quantity {
        grid-template-columns: 1fr 42px 1fr;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .ss-sticky-product-bar {
        transition: none !important;
      }
    }
  `;

  document.head.appendChild(style);
})();
